import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField/TextField';
import Grid from '@material-ui/core/Grid';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {SketchPicker} from 'react-color';
import IconButton from '@material-ui/core/IconButton';
import ClearRoundedIcon from '@material-ui/icons/ClearRounded';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: 325,
    width: 500,
  },
  textField: {
    width: '100%',
  },
  gridItem: {
    textAlign: 'center',
  },
  //legend item
  item: {
    padding: 1,
    marginRight: 10,
    paddingLeft: 20,
  },
}));

const DialogWarna = (props) => {
  const classes = useStyles();
  const {listWarna, setListWarna} = props;
  // console.log(listWarna);

  const ListWarna = (props1) => {
    const {data, index} = props1;
    const [codeWarna, setCodeWarna] = useState(data.warna);
    const [color, setColor] = useState(false);
    const handleClickColor = () => {
      setColor(true);
    };
    const handleCloseColor = () => {
      setColor(false);
    };

    const handleChangeComplete = (color) => {
      setCodeWarna(color.hex);

      let tmp = listWarna;
      tmp[index] = {
        kd_provinsi: data.kd_provinsi,
        kd_kabupaten: data.kd_kabupaten,
        kd_kecamatan: data.kd_kecamatan,
        kd_kelurahan: data.kd_kelurahan,
        nm_kelurahan: data.nm_kelurahan,
        warna: color.hex,
      };

      // console.log(tmp);
      setListWarna(tmp);
    };

    return (
      <Grid container spacing={1} style={{margin: '0px'}}>
        <Grid item xs={4}>
          <p>{data.nm_kelurahan}</p>
        </Grid>
        <Grid item xs={5} className={classes.gridItem} style={{width: '100%'}}>
          <i className={classes.item} style={{backgroundColor: codeWarna}}></i>
          <TextField
            id="standard-basic"
            value={codeWarna}
            // onChange={e=>setCodeWarna(e.target.value)}
            onClick={handleClickColor}
          />
          {color ? <SketchPicker color={codeWarna} onChangeComplete={handleChangeComplete} /> : null}
        </Grid>
        <Grid item xs={1}>
          {color ? (
            <Tooltip title="Close" arrow>
              <IconButton size="small" type="button" className={classes.iconButton} onClick={handleCloseColor} aria-label="close">
                <ClearRoundedIcon fontSize="inherit" />
              </IconButton>
            </Tooltip>
          ) : null}
        </Grid>
      </Grid>
    );
  };

  return (
    <div className={classes.root}>
      <PerfectScrollbar options={{suppressScrollX: true}}>
        <Grid container spacing={1}>
          <Grid item xs={4}>
            <p>Kelurahan</p>
          </Grid>
          <Grid item xs={7}>
            <p>Kode Warna</p>
          </Grid>

          {listWarna.map((value, key) => {
            return <ListWarna data={value} key={key} index={key} />;
          })}
        </Grid>
      </PerfectScrollbar>
    </div>
  );
};

export default DialogWarna;
